import { render, staticRenderFns } from "./ConsultCardArrow.vue?vue&type=template&id=100bbc1c"
import script from "./ConsultCardArrow.vue?vue&type=script&lang=ts"
export * from "./ConsultCardArrow.vue?vue&type=script&lang=ts"
import style0 from "./ConsultCardArrow.vue?vue&type=style&index=0&id=100bbc1c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports